import { Product, ProductLifecycleStage, ProductMake, ProductStatus, ProductType } from "@/types";
import { getData, postData, putData, deleteData } from "./axios-service"
import { ReservationStatus } from "@/types";


function modelMapper(inputProduct: any): Product {
    const aquaNb = inputProduct.aquaNb || "";
    const make = inputProduct.productMake || "";
    const type = inputProduct.productType || "";
    return {
        id: inputProduct.id,
        name: inputProduct.aquaNb,
        price: inputProduct.price,
        model: inputProduct.model,
        aquaNb: inputProduct.aquaNb,
        serialNb: inputProduct.serialNb,
        compteur: inputProduct.compteur,
        laverieId: inputProduct.laverieId,
        storageDepotId: inputProduct.storageDepotId,
        productModelId: inputProduct.productModelId,
        bonEntreeNb: inputProduct.bonEntreeNb,
        destructionDate: inputProduct.destructionDate,
        productMake: inputProduct.productMake,
        productType: inputProduct.productType,
        bonEntreeDate: inputProduct.bonEntreeDate,
        notificationEnabled: inputProduct.notificationEnabled,
        productStatus: inputProduct.productStatus,
        reservationStatus: inputProduct.reservationStatus,
        location: inputProduct.location,
        lifecycleStage: inputProduct.lifecycleStage,
        lifecycleStageLabel: inputProduct.lifecycleStageLabel,
        title: `${aquaNb} ${type} ${make}`.trim()
    };
}

export function modelMapperArray(inputArray: any[]): Product[] {
    return inputArray.map(modelMapper);
}

export async function getFilteredProducts(reservationStatuses: ReservationStatus[],
    productMake?: ProductMake, productType?: ProductType, productStatus?: ProductStatus,
    productModelId?: string, destructionDateStart?: string, destructionDateEnd?: string,
    bonEntreeDateStart?: string, bonEntreeDateEnd?: string): Promise<Product[]> {
    let url = "/products?reservation_status=" + reservationStatuses.join(",");
    if (productMake) {
        url += "&product_make=" + encodeURIComponent(productMake);
    }
    if (productType) {
        url += "&product_type=" + encodeURIComponent(productType);
    }
    if (productStatus) {
        url += "&product_status=" + encodeURIComponent(productStatus);
    }
    if (productModelId) {
        url += "&product_model_id=" + encodeURIComponent(productModelId);
    }
    if (destructionDateStart) {
        url += "&destruction_date_start=" + encodeURIComponent(destructionDateStart);
    }
    if (destructionDateEnd) {
        url += "&destruction_date_end=" + encodeURIComponent(destructionDateEnd);
    }
    if (bonEntreeDateStart) {
        url += "&bon_entree_date_start=" + encodeURIComponent(bonEntreeDateStart);
    }
    if (bonEntreeDateEnd) {
        url += "&bon_entree_date_end=" + encodeURIComponent(bonEntreeDateEnd);
    }
    const products = await getData<Product[]>(url);
    return modelMapperArray(products ?? []);
}

export function getProductById(id: string): Promise<Product> {
    return getData("/products/" + id).then(
        onSucceed => {
            return modelMapper(onSucceed);
        }
    );
}

export async function getProductsByLaverieId(laverieId: string): Promise<Product[]> {
    const url = `/products?laverieId=${laverieId}`;
    const products = await getData<Product[]>(url);
    return modelMapperArray(products);
}

export function postProduct(product: Product): Promise<Product> {
    return postData("products", product).then(
        onSucceed => {
            return modelMapper(onSucceed);
        }
    );
}

export function putProduct(id: string, product: Product): Promise<any> {
    return putData("products/" + id, product)
}

export function deleteProduct(ids: string[]): Promise<any> {
    const idsStr = ids.join(',');
    return deleteData("products/" + idsStr)
}

export async function searchForProducts(searchQuery: string): Promise<Product[]> {
    const products = await getData<Product[]>("products?" + searchQuery);
    return modelMapperArray(products ?? []);
}

export async function getProductsByLifecycleStages(lifecycleStages: ProductLifecycleStage[]): Promise<Product[]> {
    const products = await getData<Product[]>("/products?lifecycle_stage=" + lifecycleStages.join(","));
    return modelMapperArray(products ?? []);
}

// Decides to replace an installed product: creates its removal and, when given, the preparation of the replacement
export function requestReplacement(productId: string, replacementProductId?: string): Promise<any> {
    return postData("/products/" + productId + "/replacement", { replacementProductId: replacementProductId ?? null });
}
